import React from 'react'
import CarRentalBanner from './CarRentalBanner'
import HomeFlight from '../home/HomeFlight'
import FindCars from './FindCars'
import CarRentalFooterBanner from './CarRentalFooterBanner'

export default function CarRentalIndex() {
  return (
    <>
      <CarRentalBanner />
      <section className="section-equal-padding pb-0 bg-white d-none d-md-block"></section>
      <HomeFlight />
      <FindCars />
      <CarRentalFooterBanner />
    </>
  )
}
